import { render, staticRenderFns } from "./AbaNascido.vue?vue&type=template&id=6c8cb062&"
import script from "./AbaNascido.vue?vue&type=script&lang=js&"
export * from "./AbaNascido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports